<template lang="pug">
  .table-responsive
    ModalUsoEquipo(:config="configModal" @selectNewOffice="selectNewOffice" v-show="modalStatus")
    ModalDocumentosArt(v-show="modalStatusD" :tipo="tipoFileUp" :articulo="itemSelect" @padre:close="cerrarModalD" @subirDocumento="subirDocumento" @borrarDocumento="verModalDeleteDocumento")
    ModalYN(v-show="modalStatusYN" :config="configModalYN" @padre:close="borrarDocumento")
    ModalInputCompania(v-show="modalStatusCompania" :config="configModalCompania" :companias="companias" :articuloSel="articuloSel"  @changeCompania="changeCompania")
    ModalInput(v-show="modalStatusIdSAP" :config="configModalIdSAP" :articuloSel="articuloSel" @changeIdSAP="changeIdSAP")
    table#tbExistencias.table.is-striped.is-fullwidth
      thead
        tr
          th idSAP
          th Tag
          th Ubicación
          th Descripción
          th Imágenes
          th Factura
          th Compañía
      tbody
        tr(v-for="(data, index) in articulos" :key="data.id")
          td
            a.button.is-black.is-rounded.is-small(@click="verModalInputs(data, 'idSAP')") {{ data.idSAP === ''? 's/idSAP' : data.idSAP }}
          td 
            span.tag.is-black(v-show="data.tag !== ''")
              | {{ data.tag }}
          td
            a.button.is-black.is-rounded.is-small(@click="cambiarUbicacion(data)") {{ data.ubicacion }}
          td
            a.button.is-black.is-small.is-rounded(@click="irEditarArticulo(data)")
              | {{ data.categoria }}{{ data.subcategoria !== '' ? ` - ${data.subcategoria}` : '' }}
            a.button.is-light.is-rounded.is-small(@click="verHistoria(data.id)")
              i.fas.fa-history
            br
            span.tag.is-light.is-small(v-show=" data.marca !== ''") Marca: {{ data.marca }} &nbsp&nbsp
            span.tag.is-small(v-show=" data.modelo !== ''") Modelo: {{ data.modelo }} &nbsp&nbsp
            span.tag.is-small(v-show=" data.serie !== ''") Serie: {{ data.serie }} &nbsp&nbsp
            br
            span.tag.is-light.is-small(v-show="data.tipoAdm == 2") Precio Unit. {{ data.precioUnitario | currency }}
          td
            a.button.is-rounded.is-small(@click="verModalD(data, 'images')" :class="getClassTipo(data, '0')")
              i.far.fa-folder-open
              | &nbsp
              span {{ data.documentos == 0 ? ' Sin Documentos' : ` (${(data.documentos.filter( d => d.tipo === '0')).length}) Imágenes`}}
          td
            a.button.is-rounded.is-small(:class="data.rutaFac !== '' ? 'is-success': 'is-warning'" @click="verModalD(data, 'facturas')")
              i.far.fa-folder-open
              | &nbsp
              span Factura
          td
            a.button.is-light.is-rounded.is-small(@click="verModalInputs(data, 'compania')")
              span {{ data.division === '' ? 'Seleccionar' : data.division }}
          
</template>

<script>
  import ModalUsoEquipo from './ModalUsoEquipo.vue'
  import ModalDocumentosArt from './ModalDocumentosArt.vue'
  import ModalInputCompania from "./ModalInputCompania.vue"
  import ModalInput from "./ModalInput.vue"
  import ModalYN from '@/components/shared/ModalYN.vue'
  import moment from 'moment'
  import InventarioServices from '../../../services/inventario/inventario'
  import { mapState } from 'vuex'
  export default {
    name: 'TbMaquinaria',
    components: { ModalUsoEquipo, ModalDocumentosArt, ModalYN, ModalInputCompania, ModalInput },
    props: {
      articulos: {
        type: Array,
        default: []
      },
      origen: {
        type: Object,
        default: () => {},
      },
      companias: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        itemCambiar: {},
        configModal: {},
        modalStatus: false,
        itemSelect: {},
        modalStatusD: false,
        tipoFileUp: '',
        documentoSelect: {},
        modalStatusYN: false,
        configModalYN: {},
        modalStatusCompania: false,
        configModalCompania: {},
        articuloSel: {},
        modalStatusIdSAP: false,
        configModalIdSAP: {},
      }
    },
    methods: {
      inciarComponente() {
        
      },
      
      verHistoria (id) {
        this.$router.push({ path: `/Inventario/Historia/${id}` } )
      },
      irAResguardos (id) {
        if (this.permisos.inventario == 6) {
          return
        }
        this.$router.push({ path: `/Inventario/Resguardos/${id}` } )
      },
      getOC_FC (art) {
        let texto = ''
        if(art.ordenCompra === '') {

          if (art.fechaCompra === '0000-00-00'){
            texto = `<span class="is-size-7">
            <a class="button is-black is-rounded is-small">
              <i class="fas fa-history"></i>
            </a>
            </span>
            `
          } else {
            texto = `<span class="is-size-7">${art.fechaCompra}
                <a class="button is-black is-rounded is-small">
                  <i class="fas fa-history"></i>
                </a>
              </span>
              `
          }
        } else {
            if (art.fechaCompra === '0000-00-00'){
              texto = `<span class="is-size-7"><b>O.C. </b> ${art.ordenCompra}
              <a class="button is-black is-rounded is-small">
                <i class="fas fa-history"></i>
              </a>
              </span>
              `
            } else {
              texto = `<span class="is-size-7"><b>O.C. </b> ${art.ordenCompra}</span>
                <span class="is-size-7">${art.fechaCompra}
                  <a class="button is-black is-rounded is-small">
                    <i class="fas fa-history"></i>
                  </a>
                </span>
                `
            }
        }

        return texto
      },
      irEditarArticulo(data) {
        if (this.permisos.inventarios == 6) {
          return
        }
        this.$store.commit('esArticuloEspecial', true)
        this.$router.push({ path: `/Inventario/ArticuloDetalle/${data.id}` })
      },
      getTipo: function (id) {
        let result;
        let type = this.tipos.filter(tipo => tipo.id === id)
        let tipoEnc = type[0]
        if (tipoEnc.subclase === '') {
          result = tipoEnc.nombre
        } else {
          result = `${tipoEnc.nombre} (${tipoEnc.subclase})`
        }

        return result
      },
      
      cambiarUbicacion(item) {
        if (this.permisos.inventario == 6) {
          return
        }
        
        this.itemCambiar = item
        this.configModal = {
          title: 'Ubicar equipo',
          content: `Seleccione la ubicación y el estatus de: ${item.descripcion}.`,
          textCancel: 'Cancelar',
          textOk: 'Guardar'
        }
        this.modalStatus = true
        
      },
      selectNewOffice (result) {
        if (this.permisos.inventario == 6) {
          return
        }
        if (result === 'close') {
          this.modalStatus = false
          return
        }
        this.isLoading = true
        if ( Object.keys(result).length > 0 ) {
          let id = Date.now()
          let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')

          let idRec = ''
          let Rec = ''

          if (result.estatus > 8) {
            idRec = result.idUbicacion
            Rec = result.ubicacion
          } else {
            idRec = this.userLogin.id
            Rec = this.userLogin.nombre
          }

          InventarioServices.addUbicacion(id, this.itemCambiar.id, fechaReg, result.ubicacion, result.oficina, this.userLogin.id, this.userLogin.nombre, idRec, Rec, result.estatus)
            .then((data) => {
              if (data.success) {
                this.$emit('update', true)
                this.displayToast(data.respuesta, 'done', 'OK')
              } else {
                this.displayToast(`Error: ${data.respuesta}`, 'ban', 'OK')
              }
            })
            .catch((e) => {
              this.isLoading = false
              this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
            })
        }
        this.modalStatus = false
      },
      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : null,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      getEstado (child) {
        let html = ''
        switch (child.estado) {
          case 7:
            html = ` <span class='tag is-info'><i class="fas fa-laptop-house">&nbspPruebas</i></span>
            <a class="button is-black is-rounded is-small">
              <i class="fas fa-history"></i>
            </a>`
            break
          case 8:
            html = ` <span class='tag is-warning'><i class="fas fa-tools"></i>&nbspReparación</i></span>
            <a class="button is-black is-rounded is-small">
              <i class="fas fa-history"></i>
            </a>`
            break
          case 9:
            html = ` <span class='tag is-success'><i class="fas fa-database"></i>&nbspInstalado</i></span>
            <a class="button is-black is-rounded is-small">
              <i class="fas fa-history"></i>
            </a>`
            break
          case 10:
            html = ` <span class='tag is-danger'><i class="far fa-trash-alt"></i>&nbspDesechado</i></span>
            <a class="button is-black is-rounded is-small">
              <i class="fas fa-history"></i>
            </a>`
            break
        
          default:
            html = ` <a class="button is-black is-rounded is-small">
              <i class="fas fa-history"></i>
            </a>`
            break
        }
        return html
      },

      getClassTipo (item, tipo) {
        const { documentos } = item
        const isFiles = documentos.some( d => d.tipo === tipo)
        return isFiles ? 'is-success' : 'is-warning'
      },
      
      verModalD (data, tipo) {
        this.itemSelect = data
        this.modalStatusD = true
        this.tipoFileUp = tipo
      },

      cerrarModalD () {
        this.itemSelect = {}
        this.modalStatusD = false
      },

      subirDocumento (doctos) {
        if (this.permisos.inventario == 6) {
          return
        }
        this.modalStatusD = false
        this.isLoading = true
        const files = Array.from(doctos)
        if (files.length > 0) {
          var i = 0
          files.forEach(docto => {
            
            const nombreFile = docto.name
            let tipoInt = 0
            if (this.tipoFileUp !== 'facturas') {        
              switch (this.tipoFileUp) {
                case 'images':
                  tipoInt = 0
                  break
                case 'facturas':
                  tipoInt = 1
                  break
                case 'polizas':
                  tipoInt = 2
                  break
                case 'tarjetaCirc':
                  tipoInt = 3
                  break
              }
              InventarioServices.uploadDocumento(this.itemSelect.id, nombreFile, docto, tipoInt)
                .then(data => {
                  if (data.success) { i++}
                  
                  this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
                  if (i== doctos.length) {
                    this.isLoading = false
                    this.$emit('updateChildrens', this.itemSelect)
                  }
                })
                .catch( error => {
                  this.isLoading = false
                  this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
                })  
            } else {
              InventarioServices.subirFactura(this.itemSelect.id, nombreFile, docto)
                .then( data => {
                  this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
                  this.isLoading = false
                  this.$emit('updateChildrens', this.itemSelect)
                })
                .catch(error => {
                  this.isLoading = false
                  this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
                })
            }
          })
          
        } else {
          this.displayToast('bubble', 'No hay documentos seleccionadas', 'ban', 'OK')
          this.isLoading = false
        }
        
      },
      
      verModalDeleteDocumento (docto) {
        if (this.permisos.inventario == 6) {
          return
        }
        let title = ''
        let content = ''

        switch (this.tipoFileUp) {
          case 'images':
            title = 'Eliminar Documento'
            content = '¿Desea eliminar el documento?'
            break
          case 'facturas':
            title = 'Eliminar Factura'
            content = '¿Desea eliminar la factura?'
            break
          case 'polizas':
            title = 'Eliminar Póliza'
            content = '¿Desea eliminar la póliza?'
            break
        }

        this.configModalYN = {
          title: title,
          content: content,
          textCancel: 'Cancelar',
          textOk: 'Eliminar'
        }
        this.modalStatusD = false
        this.documentoSelect = docto
        this.modalStatusYN = true
      },

      borrarDocumento (result) {
        if (this.permisos.inventario == 6) {
          return
        }
        this.modalStatusYN = false
        this.isLoading = true
        if (result) {
          
          if (this.documentoSelect.tipo === 'documento') {
            InventarioServices.deleteDocumento(this.documentoSelect.id, this.documentoSelect.ruta)
              .then(data => {
                this.$emit('updateChildrens', this.itemSelect)
                this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
              })
              .catch( error => {
                this.isLoading = false
                this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
              })
          } else {
            InventarioServices.deleteFactura(this.documentoSelect.id, this.documentoSelect.rutaFac)
              .then(data => {
                this.$emit('updateChildrens', this.itemSelect)
                this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
              })
              .catch( error => {
                this.isLoading = false
                this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
              })
          }
        } else {
          this.isLoading = false
          this.modalStatusD = true
        }
        this.documentoSelect = {}
      },
      displayToast(tema,text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },

      verModalInputs(data, input) {
        if (input === 'compania') {
            this.articuloSel = {}
            this.configModalCompania = {
              title: 'Compañía',
              content: 'Seleccione una compañía',
              classCancel: 'is-light',
              textCancel: 'Cancelar',
              classOk: 'is-dark',
              textOk: 'Guardar'
            }
          this.articuloSel = {
            id_articulo: data.id,
            id_division: data.id_division
          }
          this.modalStatusCompania = true
        } else {
          this.articuloSel = {}
          this.configModalIdSAP = {
            title: 'IdSAP',
            content: 'Escriba el idSAP',
            classCancel: 'is-light',
            textCancel: 'Cancelar',
            classOk: 'is-dark',
            textOk: 'Guardar'

          }
          this.articuloSel = {
            id_articulo: data.id,
            idSAP: data.idSAP
          }
          this.modalStatusIdSAP = true
        }
      },
      changeCompania(data) {
        if (data === 'close') {
          this.articuloSel = null
          this.modalStatusCompania = false
          return
        }
        InventarioServices.changeCompania(data.id_articulo, data.compania)
          .then( data => {
            if (data.success) {
              this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'OK')
              this.$emit('update', true)
              this.modalStatusCompania = false
            } else {
              this.displayToast('bubble', data.respuesta, 'ban', 'OK')
            }
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast('bubble',e.message, 'ban', 'OK')      
          })
      }, 
      changeIdSAP(data) {
        if (data === 'close') {
          this.articuloSel = null
          this.modalStatusIdSAP = false
          return
        }
        InventarioServices.changeIdSAP(this.articuloSel.id_articulo, data)
          .then( data => {
            if (data.success) {
              this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'OK')
              this.$emit('update', true)
              this.modalStatusIdSAP = false
            } else {
              this.displayToast('bubble', data.respuesta, 'ban', 'OK')
            }
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast('bubble',e.message, 'ban', 'OK')      
          })
      },

    },
    created () {
      this.inciarComponente()
    },
    computed: {
      ...mapState(['userLogin', 'permisos'])
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/shared/TbMaquinaria.vue